export default __webpack_public_path__ + "static/media/rotate.06d16180.png";